class DealTickerFilter {
    constructor(app) {
        this.app = app
        this.filter = this.app.querySelector('[data-filter]')
        this.accordions = [...this.app.querySelectorAll('[data-accordion]')]
        this.currentFilter = []
        this.selectAll = this.app.querySelector('#filter-select-all')
        this.init()

    }

    init() {
        this.filter.addEventListener('change', () => this.update())
        this.selectAll.addEventListener('change', () => this.filter.reset())

    }

    update() {
        // get all checked options
        const formData = new FormData(this.filter)
        this.currentFilter = [...formData.values()].filter(e => e)
        // uncheck all if a option is set
        this.selectAll.checked = this.currentFilter.length == 0

        // hide not maching accordions
        this.accordions.map(el => this.toggleElement(el, this.currentFilter.length !== 0 && !this.currentFilter.includes(el.dataset.accordion)))

    }

    toggleElement(el, force) {
        el.classList.toggle('display-none', force)
        el.open = true

    }
}

export default DealTickerFilter
